import axios from 'axios'




export const userLogin = async(authUser) =>{
    return await axios.post(`${process.env.REACT_APP_API}/user-login`,authUser)
}


export const getUserById = async(token) =>{
    return await axios.get(`${process.env.REACT_APP_API}/auth`,{
        headers:{
            "x-auth-token":token
        }
    })
}

export const getUserByIdReal = async(id,token) =>{
    return await axios.post(`${process.env.REACT_APP_API}/user-by-id`,id,{
        headers:{
            "x-auth-token":token
        }
    })
}


export const getUsers = async(token) =>{
    return await axios.get(`${process.env.REACT_APP_API}/users`,{
        headers:{
            "x-auth-token":token
        }
    })
}


export const createUser = async(body,token) =>{
    return await axios.post(`${process.env.REACT_APP_API}/user-register`,body,{
        
        headers:{
            "x-auth-token":token
        }
    })
}

export const updateUser = async(body,token) =>{
    return await axios.put(`${process.env.REACT_APP_API}/user-update`,body,{
        
        headers:{
            "x-auth-token":token
        }
    })
}